<template>
  <v-tabs v-model="active" color="primary" dark slider-color="yellow">
    <v-tab :key="1"
      >{{ $tc('common.Course', 2) }} {{ $t('common.And') }}
      {{ $tc('common.Congress', 2) }}</v-tab
    >
    <v-tab :key="2"
      >{{ $tc('common.Communication', 2) }} {{ $t('common.And') }}
      {{ $tc('common.Publication', 2) }}</v-tab
    >
    <v-tab :key="3">{{ specialty }}</v-tab>
    <v-tab :key="4" v-if="reportsAvaliable">{{$tc("common.Report", 2) }}</v-tab>
    <v-tab-item>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <statistics-list :data-to-display="coursesStats"></statistics-list>
          </v-flex>
          <v-flex xs12 md6>
            <statistics-list :data-to-display="congressStats"></statistics-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-tab-item>
    <v-tab-item>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <statistics-list
              :data-to-display="comunicationStats"
            ></statistics-list>
          </v-flex>
          <v-flex xs12 md6>
            <statistics-list
              :data-to-display="publicationsStats"
            ></statistics-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-tab-item>
    <v-tab-item>
      <v-container>
        <log-statistics-tab></log-statistics-tab>
      </v-container>
    </v-tab-item>
    <v-tab-item>
      <v-container>
        <report-statistics @reportsAvaliable="reportsAvaliable = $event"></report-statistics>
      </v-container>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import StatisticsList from '@/components/StatisticsList'
import ReportStatistics from './Statistics/ReportStatistics'
import cms from '@/content'
import LogStatisticsTab from '@/views/Statistics/StatisticsTab'
import scientificActivityFetcher from '@/mixins/scientificActivityFetcher'
import trainningActivityFetcher from '@/mixins/trainningActivityFetcher'
import { mapGetters, mapActions } from 'vuex'
import { ScientificActivityMapper } from '@/statistics/scientificActivity'
import { TrainingActivityMapper } from '@/statistics/trainingActivity'
import { Component } from '@/models/Specialty'

export default {
  mixins: [scientificActivityFetcher, trainningActivityFetcher],
  components: {
    StatisticsList,
    ReportStatistics,
    LogStatisticsTab,
  },
  data() {
    return {
      loadingComponents: true,
      loadingLogs: true,
      coursesStatsValues: {},
      congressStatsValues: {},
      communicationsStatsValues: {},
      publicationsStatsValues: {},
      active: 0,
      reportsAvaliable: false,
    }
  },
  computed: {
    ...mapGetters(['courses', 'scientificActivities', 'user']),
    specialty() {
      return cms.getSpecialtyById(this.user.specialty, this.$i18n.locale)
    },
    components(){
      return Component.all()
    },
    scientificActivityLogbookOptions() {
      const testComponent = Component.query()
        .where('$id', 'scientificActivity.logbook')
        .first()
      return ScientificActivityMapper.getOptions(testComponent)
    },
    coursesStats() {
      return this.getList(
        'Act. Formativas',
        TrainingActivityMapper,
        this.courses,
        'course-type',
        'scope'
      )
    },
    congressStats() {
      return this.getList(
        'Congressos',
        TrainingActivityMapper,
        this.courses,
        'scope',
        'scope'
      )
    },
    comunicationStats() {
      return this.getList(
        'Comunicações',
        ScientificActivityMapper,
        this.scientificActivities,
        'communication-type',
        'authors'
      )
    },
    publicationsStats() {
      return this.getList(
        'Publicações',
        ScientificActivityMapper,
        this.scientificActivities,
        'publication-type',
        'authors'
      )
    },
  },
  methods: {
    ...mapActions(['getScientificActivities', 'getCourses']),
    getComponent(componentType, id) {
      if (id) {
        return Component.query().withAllRecursive().where('uid', `${componentType}.${id}`).first()
      }
      return null
    },
    getList(title, mapper, logs, group1id, group2id) {
      const lines = []
      const group1Options = mapper.getOptions(this.getComponent(mapper.specialty, group1id))
      const group2Options = mapper.getOptions(this.getComponent(mapper.specialty, group2id))
      const group1Checker = mapper.components[group1id]
        ? mapper.components[group1id].checker
        : mapper.checker
      const group2Checker = mapper.components[group2id]
        ? mapper.components[group2id].checker
        : mapper.checker

      if (logs) {
        group1Options.forEach((opt1) => {
          group2Options.forEach((opt2) => {
            lines.push({
              title: opt1.text !== opt2.text ? `${opt1.text} - ${opt2.text}` : opt1.text,
              value: logs.filter(
                (log) =>
                  group1Checker(log, group1id, opt1) &&
                  group2Checker(log, group2id, opt2)
              ).length,
            })
          })
        })
      }

      return {
        title,
        lines,
      }
    },
  },
  created() {
    this.fetchScientificActivity().then(() => {
      this.loadingComponents = false
    })
    this.getScientificActivities()
      .catch((err) =>
        this.showErrorSnackbar(err.message || 'Something went wrong')
      )
      .finally(() => {
        this.loadingLogs = false
      })
    this.fetchTrainningActivity().then(() => {
      this.loadingComponents = false
    })
    this.getCourses()
      .catch((err) =>
        this.showErrorSnackbar(err.message || 'Something went wrong')
      )
      .finally(() => {
        this.loadingLogs = false
      })
  },
}
</script>